import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { DayData, ProjectData, WeekDays } from '@components/calendar/calendar-day/calendar-day.model';

@Component({
  selector: 'app-filas-modal-week',
  templateUrl: './filas-modal-week.component.html',
  styleUrls: ['./filas-modal-week.component.scss']
})
export class ModalWeekComponentRows implements OnInit {

  @Input() dataRow: ProjectData;
  @Input() fechaIni: string;
  @Input() endDate: string;
  @Output() actualizar: EventEmitter<any> = new EventEmitter();
  guardias = false;
  lockedDays = false;

  constructor() { }

  ngOnInit() {
    this.selectedActivity();
  }

  selectedActivity() {
    this.lockedDays = false;
    if (this.dataRow.activityTypeId === '1') {
      this.lockedDays = true;
    }
  }


  insertProject(projectData): void {
    this.dataRow.projectId = projectData.Id;
    this.dataRow.sapId = projectData.name;
    this.dataRow.mpwId = projectData.manPowId;
  }

  // changeHour(dataRow): void {
  //   this.actualizar.emit(dataRow);
  // }

  mostrarComentario(day: WeekDays) {
    const estadoPrevio = day.commentShown;
    for(const i in this.dataRow.days) {
      if(this.dataRow.days[i].commentShown) {
        this.dataRow.days[i].commentShown = false;
      }
    }
    day.commentShown = estadoPrevio ?  false : true;
  }

}
